import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GroupModuleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GroupModule",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.92 30h-4.31c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h3.23v-3.23c0-.59.48-1.08 1.08-1.08s1.08.48 1.08 1.08v4.31c0 .59-.48 1.08-1.08 1.08m-10.04 0h-5.77c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h5.76c.59 0 1.08.48 1.08 1.08S19.47 30 18.87 30zm-11.5 0h-4.3C2.49 30 2 29.52 2 28.92v-4.31c0-.59.48-1.08 1.08-1.08s1.08.48 1.08 1.08v3.23h3.23c.59 0 1.08.48 1.08 1.08S7.99 30 7.39 30ZM3.07 19.95c-.59 0-1.08-.48-1.08-1.08v-5.76c0-.59.48-1.08 1.08-1.08s1.08.48 1.08 1.08v5.76c0 .59-.48 1.08-1.08 1.08m0-11.49c-.59 0-1.08-.48-1.08-1.08v-4.3c0-.59.48-1.08 1.08-1.08h4.31c.59 0 1.08.48 1.08 1.08 0 .59-.48 1.08-1.08 1.08H4.15v3.23c0 .59-.48 1.08-1.08 1.08Zm15.81-4.31h-5.77c-.59 0-1.08-.48-1.08-1.08 0-.59.48-1.08 1.08-1.08h5.76c.59 0 1.08.48 1.08 1.08 0 .59-.48 1.07-1.07 1.08m10.04 4.31c-.59 0-1.08-.48-1.08-1.08V4.15h-3.23c-.59 0-1.08-.48-1.08-1.08 0-.59.48-1.08 1.08-1.08h4.31c.59 0 1.08.48 1.08 1.08v4.31c0 .59-.48 1.08-1.08 1.08m0 11.49c-.59 0-1.08-.48-1.08-1.08v-5.76c0-.59.48-1.08 1.08-1.08s1.08.48 1.08 1.08v5.76c0 .59-.48 1.08-1.08 1.08M6.58 7.16h19.13v7.29H6.58zm0 9.85h19.13v7.29H6.58z"
    })
  }));
};